import { Link } from "react-router-dom";
import type { ReactNode } from "react";

export type Crumb = { label: string; to?: string };

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="text-sm text-foreground-500">
      <ol className="flex flex-wrap items-center gap-1.5">
        <li>
          <Link to="/" className="transition-colors hover:text-primary-700">首页</Link>
        </li>
        {items.map((item, idx) => {
          const last = idx === items.length - 1;
          return (
            <li key={`${item.label}-${idx}`} className="flex items-center gap-1.5">
              <i className="ri-arrow-right-s-line text-foreground-300" aria-hidden="true"></i>
              {item.to && !last ? (
                <Link to={item.to} className="transition-colors hover:text-primary-700">{item.label}</Link>
              ) : (
                <span aria-current="page" className="text-foreground-800">{item.label}</span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

export type { ReactNode };